// src/components/Avatar.js
// Circular avatar with a deterministic gradient fallback when there's no image.

const GRADIENTS = [
  ["#9333EA", "#EC4899"],
  ["#6366F1", "#8B5CF6"],
  ["#EC4899", "#F97316"],
  ["#0EA5E9", "#6366F1"],
  ["#10B981", "#0EA5E9"],
  ["#F97316", "#EC4899"],
];

function pick(name = "?") {
  let sum = 0;
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i);
  return GRADIENTS[sum % GRADIENTS.length];
}

export default function Avatar({ name = "?", url, size = 40, radius = "50%" }) {
  const style = { width: size, height: size, minWidth: size, borderRadius: radius };
  if (url) return <img className="avatar" src={url} alt={name} style={style} />;
  const [a, b] = pick(name);
  return (
    <div
      className="avatar avatar--fallback"
      style={{ ...style, background: `linear-gradient(135deg, ${a}, ${b})`, fontSize: size * 0.4 }}
    >
      {name.charAt(0).toUpperCase()}
    </div>
  );
}
